var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaceBook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1897 22.8873L30.2858 15.8124H23.5338V11.2137C23.5338 9.2791 24.4764 7.38877 27.4907 7.38877H30.6036V1.36402C28.7908 1.07034 26.9591 0.911467 25.1231 0.888672C19.5659 0.888672 15.9378 4.28243 15.9378 10.4177V15.8124H9.77777V22.8873H15.9378V39.9998H23.5338V22.8873H29.1897Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceBook);
export default __webpack_public_path__ + "static/media/FaceBook.64f84f041d1573cca804b68b640c6492.svg";
export { ForwardRef as ReactComponent };